import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Alert, Tabs, Tab } from 'react-bootstrap';
import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import { cfpFieldGroups } from '../field_group/CFPFields';
import Thumbnail from '../thumbnail/Thumbnail';
import RelationDataTable from '../datatable/RelationDataTable';
import MaterialLayerPreviewer from '../material/MaterialLayerPreviewer';
import MaterialLayerPreviewerHorizontal from '../material/MaterialLayerPreviewerHorizontal';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue,  stringifyErrorMessage,  toCenti,  fromCenti,  defaultRejectHandler} from '../../utils/utility';
import { searchOpaqueMaterialOrAirGap } from '../../redux/material_opaque/material_actions';
import {
  addMaterialToComponent,
  removeMaterialFromComponent,
  editMaterialFromComponent,
  listMaterialInComponent,
  clearMaterialOpaque,
} from '../../redux/component/component_material_actions';
import {
  listHeatDissipation,
  listSolarAbsorptance,
} from '../../redux/references/envelop_actions';
import { listMaterialOpaque } from '../../redux/material_opaque/material_actions';
import Constants from '../../config/constants';
export class ComponentOpaqueDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;

    this.search = {
      pageSize: this.DEFAULT_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    this.materialDetail = null;

    this.state = {
      isShowDeleteModal: false,
      materialToComponentArr: [],
      isMaterialEditing: false,
      isMaterialRemoving: false,
    };

    const { t } = props;

    this.columns = [
      {
        Header: '',
        accessor: 'material.thumbnail',
        Cell: (row) => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'material.name',
        ...getColumnStyle(COLUMN_STYLE.text),
        entity: {
          list: (text, page) =>
            searchOpaqueMaterialOrAirGap(text, page).then((response) =>
              response.data.map(({ name, id }) => ({
                label: name,
                value: String(id),
              }))
            ),
          create: null,
        },
      },
      {
        Header: () => (
          <b>
            {t('thickness')} ({t('unit_cm')})
          </b>
        ),
        accessor: 'thickness',
        ...getColumnStyle(COLUMN_STYLE.coefficient),
        width: 140,
        attr: {
          type: 'number',
          isRequired: true,
          props: {
            min: 0.0,
            step: 'any',
          },
        },
      },
      {
        Header: () => <b>{t('order')}</b>,
        accessor: 'order',
        ...getColumnStyle(COLUMN_STYLE.decimal),
        width: 140,
        attr: {
          type: 'number',
          isRequired: true,
          props: {
            min: 0,
            step: 1,
          },
        },
      },
    ];
  }

  getComponentData() {
    return this.formRef.getFormData();
  }

  renderOption(item, prefix) {
    const { t } = this.props;
    return (
      <option key={prefix ? `${prefix}${item.id}` : item.id} value={item.id}>
        {t(String(item.name).toLowerCase())}
      </option>
    );
  }

  componentDidMount() {
    if (this.props.listHeatDissipation) {
      this.props.listHeatDissipation();
    }
    if (this.props.listSolarAbsorptance) {
      this.props.listSolarAbsorptance();
    }
    if (this.props.listMaterialToSelect) {
      this.props.listMaterialToSelect();
    }
  }

  renderBasicInfo() {
    const {
      name,
      solar_absorptance_id,
      heat_dissipation_id,
      description,
      image,
      cfp_value,
      cfp_unit,
    } = this.props.component;
    const { disabled, fieldErrors, errorMessage, t, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form {...otherAttr} image={image} ref={(ref) => (this.formRef = ref)} >
        <FieldGroup
          id='component-opaque-name'
          field='name'
          type='text'
          label={t('name')}
          placeholder={t('opaque component name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id='component-opaque-outer-surface-color'
          field='solar_absorptance_id'
          componentClass='select'
          label={t('outer surface color')}
          value={solar_absorptance_id}
          defaultDirty={true}
          errorMessage={getErrorValue(fieldErrors, 'solar-absorptance')}
          {...customAttr}
          disabled={!!(this.props.solarAbsorptanceLoading || disabled)}
        >
          {this.props.solarAbsorptanceList
            .map((item) => ({
              name: t(
                Constants.MAPPER.outer_surface_colors[item.solar_absorptance]
              ),
              id: item.id,
            }))
            .map((item) => this.renderOption(item, 'sab'))}
        </FieldGroup>
        <FieldGroup
          id='component-opaque-inner-surface'
          field='heat_dissipation_id'
          componentClass='select'
          label={t('inner surface')}
          value={heat_dissipation_id}
          defaultDirty={true}
          errorMessage={getErrorValue(fieldErrors, 'heat-dissipation')}
          {...customAttr}
          disabled={!!(this.props.heatDissipationListLoading || disabled)}
        >
          {this.props.heatDissipationList
            .map((item) => ({
              name: item.heat_dissipation,
              id: item.id,
            }))
            .map((item) => this.renderOption(item, 'hdp'))}
        </FieldGroup>
        {cfpFieldGroups({ cfp_value, cfp_unit, disabled, fieldErrors, t })}
        <FieldGroup
          id='component-opaque-description'
          field='description'
          componentClass='textarea'
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;
    if (this.props.component.id) {
      this.props.listMaterial(
        this.search.pageSize,
        this.search.page,
        this.search.sorted,
        this.search.filtered,
        {
          all: null,
          public: true,
          private: false,
        }[category]
      );
    }

    this.setState({ categoryOption: category });
  }

//// clear material data on redux 
  componentWillUnmount(){
    this.props.clearMaterialOpaqueOnRedux();
  }

  createMaterialToComponentState(name, entityId, thickness, order) {
    const material = { id: entityId, name };
    this.setState({
      materialToComponentArr: [
        ...this.state.materialToComponentArr,
        { material,material_id:entityId, thickness:parseFloat(thickness), order }]
    }, ()=>this.setState({materialToComponentArr: [...this.state.materialToComponentArr.sort((a, b) => a.order - b.order)]}));
  }
  
  editMaterialToComponent(thickness, order,index) {
    let tmpMaterial = this.state.materialToComponentArr;
    tmpMaterial[index].thickness =parseFloat(thickness); 
    tmpMaterial[index].order =order; 
    tmpMaterial.sort((a, b) => a.order - b.order);
    this.setState({materialToComponentArr: tmpMaterial ,isMaterialEditing:true},()=>this.setState({isMaterialEditing:false}))
  }

  removeMaterialToComponentState(index){
    let materialArr =  [...this.state.materialToComponentArr];
    materialArr.splice(index,1);
    this.setState({materialToComponentArr:materialArr,isMaterialRemoving:true},()=>this.setState({isMaterialRemoving:false}))
  }

  renderMaterialsWithoutComponentId = () => {
    const {
      component: { id: componentId },
      componentMaterials: materials,
      filteredCount,
    } = this.props;

    const relationship = {
      create: ({ name, entityId, thickness, order}) =>
        this.createMaterialToComponentState(name, entityId, thickness, order),
      edit: ({ thickness, order },index) =>
      this.editMaterialToComponent(thickness, order,index), 

      delete: (index) =>this.removeMaterialToComponentState(index),
      isCreating: this.props.isMaterialAdding,
      isDeleting: this.state.isMaterialRemoving,
      isEditing: this.state.isMaterialEditing,
    };
    return (
      <RelationDataTable
        columns={this.columns}
        data={this.state.materialToComponentArr}
        relationship={relationship}
        relationshipNameAccessor={(item) => item.material.name}
        classNamePrefix='select-material-component'
        filteredCount={filteredCount || (materials && materials.length) || 0}
        onActionEdit={(material) =>
          this.setState({ isShowEditModal: true, selectedMaterial: material })
        }
        onActionDelete={(material) =>
          this.setState({ isShowDeleteModal: true, selectedMaterial: material })
        }
        onFetchData={(state) =>
          this.updateSortFilter(
            this.search.filtered,
            state,
            this.state.categoryOption
          )
        }
      />
    );
  };
  renderMaterials() {
    const {
      component: { id: componentId },
      componentMaterials: materials,
      filteredCount,
    } = this.props;
    const relationship = {
      create: ({ entityId, thickness, order }) =>
        this.props.addMaterial(componentId, entityId, thickness, order),
      edit: ({ id, thickness, order }) =>
        this.props.editMaterial(id, parseFloat(thickness), order),
      delete: (id) => this.props.removeMaterial(id),
      isCreating: this.props.isMaterialAdding,
      isDeleting: this.props.isMaterialRemoving,
      isEditing: this.props.isMaterialEditing,
    };

    return (
      <RelationDataTable
        columns={this.columns}
        data={materials.sort((a, b) => a.order - b.order)}
        relationship={relationship}
        relationshipNameAccessor={(item) => item.material.name}
        classNamePrefix='select-material-component'
        filteredCount={filteredCount || materials.length}
        onActionEdit={(material) =>
          this.setState({ isShowEditModal: true, selectedMaterial: material })
        }
        onActionDelete={(material) =>
          this.setState({ isShowDeleteModal: true, selectedMaterial: material })
        }
        onFetchData={(state) =>
          this.updateSortFilter(
            this.search.filtered,
            state,
            this.state.categoryOption
          )
        }
      />
    );
  }

  renderLayerPreview() {
    const { componentMaterials: materials, component, t  } = this.props;
    const {materialToComponentArr}  = this.state;
    const normMaterials = (materialToComponentArr.length>0?materialToComponentArr:materials).map(({ id, material, thickness }) => ({
      id,
      name: material.name,
      material_id: material.id,
      thickness,
    }));
    const unit = t('unit_cm');
    return component.orientation === 'horizontal' ? (
      <MaterialLayerPreviewerHorizontal
        materials={normMaterials}
        unit={unit}
      />
    ) : (
      <MaterialLayerPreviewer materials={normMaterials} unit={unit} />
    );
  }

  renderErrorMessage(errorMessage) {
    if (!errorMessage) return null;
    return (
      <Alert bsStyle='danger' style={{ 'white-space': 'pre' }}>
        {errorMessage}
      </Alert>
    );
  }

  render() {
    const {
      component,
      componentMaterials: materials,
      errorMessage,
      material,
      t,
    } = this.props;
    const detailError = stringifyErrorMessage(errorMessage);
    if(this.props.materialsToComponent){
      this.props.materialsToComponent(this.state.materialToComponentArr);
    }
    return (
      <React.Fragment>
        {detailError ? this.renderErrorMessage(detailError) : null}
        <Tabs defaultActiveKey={1} id='component-tabs'>
          <Tab eventKey={1} title={t('basic info')}>
            {this.renderBasicInfo()}
          </Tab>
        
          {component.id ? (
            <Tab eventKey={2} title={t('materials')}>
              {this.renderMaterials()}
            </Tab>
          ) : (
            <Tab eventKey={2} title={t('materials')}>
              {this.renderMaterialsWithoutComponentId()}
            </Tab>
          )}
          {materials ? (
            <Tab eventKey={3} title={t('preview')}>
              {this.renderLayerPreview()}
            </Tab>
          ) : (null)}
        </Tabs>
      </React.Fragment>
    );
  }
}

ComponentOpaqueDetail.defaultProps = {
  component: {},
};

const mapStateToProps = (state) => ({
  isEditing: state.component.opaque.isEditing,
  componentMaterials: state.componentMaterial.orderedIds.map((id) => {
    let cm = state.componentMaterial.objects[id];
    return {
      ...cm,
      thickness: toCenti(cm.thickness),
    };
  }),
  isLoading: state.componentMaterial.isLoading,
  filteredCount: state.componentMaterial.filteredCount,
  isMaterialAdding: state.componentMaterial.isCreating,
  isMaterialEditing: state.componentMaterial.isEditing,
  isMaterialRemoving: state.componentMaterial.isDeleting,
  heatDissipationList: state.reference.envelop.heatDissipationList,
  heatDissipationListLoading:
    state.reference.envelop.heatDissipationListLoading,
  solarAbsorptanceList: state.reference.envelop.solarAbsorptanceList,
  solarAbsorptanceLoading: state.reference.envelop.solarAbsorptanceLoading,
  errorMessage:
    state.component.opaque.errorMessage || state.componentMaterial.errorMessage,
  materials: state.material.opaque.orderedIds.map(
    (id) => state.material.opaque.materials[id]
  ),
  materialOnState: state.componentMaterial.materialOnState,


});

const mapDispatchToProps = (dispatch, ownProps) => ({
  listMaterial: (pageSize, page, sorted, filtered, isPublic) =>
    dispatch(
      listMaterialInComponent(
        pageSize,
        page,
        sorted,
        filtered,
        isPublic,
        ownProps.component.id
      )
    ),
  addMaterial: (componentId, materialId, thickness, order) =>
    dispatch(
      addMaterialToComponent(
        componentId,
        materialId,
        fromCenti(thickness),
        order
      )
    ),
  removeMaterial: (id) => dispatch(removeMaterialFromComponent(id)),
  editMaterial: (id, thickness, order) =>
    dispatch(editMaterialFromComponent(id, fromCenti(thickness), order)),
  listHeatDissipation: () => dispatch(listHeatDissipation()),
  listSolarAbsorptance: () => dispatch(listSolarAbsorptance()),
  listMaterialToSelect: (pageSize, page, sorted, search, filtered, isPublic) =>
    defaultRejectHandler(
      dispatch(
        listMaterialOpaque(pageSize, page, sorted, search, filtered, isPublic)
      )
    ),
  clearMaterialOpaqueOnRedux: ()=> dispatch(clearMaterialOpaque()),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true }
  )(ComponentOpaqueDetail)
);



// WEBPACK FOOTER //
// ./src/components/component_opaque/ComponentOpaqueDetail.js